import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HTTPCONSTANTS, MerchantService} from '@odin/odin-core';
import type { SettlementReports } from '../models/settlement-daily-report';
import {of} from "rxjs";

@Injectable({ providedIn: 'root' })
export class SettlementReportsService {
  private readonly baseUrl: string = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.odinBaseAddress}`;

  constructor(private readonly http: HttpClient, private merchantService: MerchantService) {}

  public getDailySettlementReport(reportDate: string, merchantRef: string) {
    const merchantMid = this.merchantService.getCurrentMid();
    if (merchantMid === null || merchantMid === undefined) return of();
    const url = `${this.baseUrl}/transactions/v1/report/settlement/${merchantRef}/?monekId=${merchantMid.monekId}&date=${reportDate}`;
    return this.http.get<SettlementReports>(url);
  }

  public getMonthlySettlementReport(reportDate: Date, merchantRef: string) {
    const merchantMid = this.merchantService.getCurrentMid();
    if (merchantMid === null || merchantMid === undefined) return of();

    const url = `${
      this.baseUrl
    }/transactions/v1/report/settlement/${merchantRef}/?monekId=${merchantMid.monekId}&date=${reportDate.toISOString()}&isMonthly=true`;
    return this.http.get<SettlementReports>(url);
  }

  public getMonthlySettlementReportCSV(reportDate: Date, merchantRef: string) {
    const merchantMid = this.merchantService.getCurrentMid();
    if (merchantMid === null || merchantMid === undefined) return of();
    const url = `${this.baseUrl}/transactions/v1/report/settlement/${merchantRef}/csv?monekId=${merchantMid.monekId}`;
    const body = {
      date: reportDate.toISOString(),
      isMonthly: true,
    };
    return this.http.post<SettlementReports>(url, body);
  }

  public getDailySettlementReportCSV(reportDate: Date, merchantRef: string) {
    const merchantMid = this.merchantService.getCurrentMid();
    if (merchantMid === null || merchantMid === undefined) return of();
    const url = `${this.baseUrl}/transactions/v1/Report/settlement/${merchantRef}/csv?monekId=${merchantMid.monekId}`;
    const body = {
      date: reportDate.toISOString(),
      isMonthly: false,
    };
    return this.http.post<SettlementReports>(url, body);
  }
}
